import {
  Body,
  Button,
  Link,
  useModals,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import PDFViewer from '~/components/shared/PDFViewer/PDFViewer';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import {
  companyCreditCheckAgencies,
  getMarketHasCreditCheckConsentDisclosure,
} from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { isInIframe } from '~/iframeMode';
import { RootState } from '~/store';
import { ApiStatus } from '~/store/types/sharedTypes';
import useGoToPreviousStep from '../../../useGoToPreviousStep';
import useSubmit from '../../../useSubmit';

export const AdditionalInformationFooter = () => {
  const {
    cardApplication: { apiStatus: applicationApiStatus },
    intl: { market },
  } = useSelector((state: RootState) => state);
  const onSubmit = useSubmit();
  const onBackButtonClick = useGoToPreviousStep();
  const t = useTranslate();
  const { isMobile } = useWindowProperties();
  const { formatList } = useIntl();
  const modal = useModals();

  const applicationApiRequestInProgress = [
    applicationApiStatus.get,
    applicationApiStatus.patch,
    applicationApiStatus.post,
  ].includes(ApiStatus.Started);

  const agencies = companyCreditCheckAgencies[market];

  const openPdfViewerModal = (fileSrc: string) => {
    if (isInIframe) {
      window.open(fileSrc, '_blank', 'noopener,noreferrer');
    } else {
      modal.openModal({
        size: isMobile ? 'md' : 'xl',
        children: <PDFViewer file={fileSrc} />,
      });
    }
  };

  const openUrl = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {isInIframe && (
        <Button
          variant="secondary"
          onClick={onBackButtonClick}
          fullWidth={isMobile}
          size={'md'}
        >
          {t('Back')}
        </Button>
      )}
      <NextButton
        label="CardApplication.Submit"
        isLoading={applicationApiRequestInProgress}
        action={onSubmit}
      />
      {getMarketHasCreditCheckConsentDisclosure(market) && (
        <Body color="Text/Secondary" size="sm" display="block">
          {t('CardApplication.CreditCheckConsent', {
            agencies: formatList(
              agencies.map((agency) => {
                return (
                  <Link
                    data-record
                    key={agency.id}
                    onClick={() => {
                      if (agency.pdfPath) {
                        openPdfViewerModal(agency.pdfPath);
                      } else if (agency.url) {
                        openUrl(agency.url);
                      }
                    }}
                    size="sm"
                  >
                    {agency.label}
                  </Link>
                );
              })
            ),
            next: `${t('CardApplication.Submit') as string}`,
          })}
        </Body>
      )}
    </>
  );
};
